import { useViewerXrayAutoWindow } from '../../viewer/window/xrayAutoWindow';
import { useAccountChoice } from './accountChoice';

/** What Settings says of it, in both editions. */
export const XRAY_AUTO_WINDOW_BLURB = 'When on, X-ray images open with automatic window and level applied already.';

/**
 * [on, set]: X-rays open on the automatic window (viewer/window/xrayAutoWindow).
 * An account preference (`viewerXrayAutoWindow`) kept in step with this
 * browser's copy; set from community's Settings or enterprise's profile page,
 * and read by the viewer's own pages so the account's choice reaches it on any
 * device.
 */
export function useViewerXrayAutoWindowSetting(): [boolean, (on: boolean) => void] {
  const local = useViewerXrayAutoWindow((s) => s.on);
  const setLocal = useViewerXrayAutoWindow((s) => s.set);
  return useAccountChoice('viewerXrayAutoWindow', local, setLocal);
}
